// Function preprocess entry for `@fun:` extraction and `@fun` call expansion.
// Pipeline: strip definitions -> expand statement calls -> return warnings.
import type { LuisFunctionExpansionResult } from './types'
import { extractFunctionDefinitions } from './definitions'
import { expandFunctionCalls } from './calls'

// Expand all user-defined function calls from source text.
export function expandLuisFunctions(source: string, collectWarnings = true): LuisFunctionExpansionResult {
  const extracted = extractFunctionDefinitions(source, collectWarnings)
  const expandedCalls = expandFunctionCalls(extracted.source, extracted.functions, collectWarnings)
  // Return function-expanded source and merged warning list.
  return {
    source: expandedCalls.source,
    warnings: [...extracted.warnings, ...expandedCalls.warnings],
  }
}
